import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";
import TeamLoss from "../../../../enums/team-loss";

export default class PassSackStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.PassSacked &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { teamLossOnly } = gameContext.gameConfig.general || {};
        const sackTeamLossOnly = teamLossOnly?.some(
            (code) => code === TeamLoss.Sack.code
        );

        const startFragment = play.getPreceedingFragment(fragment, [
            FootballState.Pass,
            FootballState.PatPass
        ]);

        const yards_lost =
            (fragment.sackedAt - gameContext.fieldPosition) *
            gameContext.getFieldDirectionMultiplier();

        const stats = [];
        if (!sackTeamLossOnly) {
            this.addStats(
                {
                    gameId: play.gameId,
                    playId: play.id,
                    period: gameContext.currentPeriod,
                    teamId: startFragment.passedBy.teamId,
                    playerId: startFragment.passedBy.id,
                    driveId: gameContext.currentDriveId,
                    fragmentId: startFragment.id,
                    category: FootballStatsCategory.RUSH,
                    values: {
                        attempted: 1,
                        completed: 1,
                        yards: yards_lost
                    }
                },
                stats
            );
        }

        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: startFragment.passedBy.teamId,
                playerId: startFragment.passedBy.id,
                driveId: gameContext.currentDriveId,
                fragmentId: startFragment.id,
                category: FootballStatsCategory.OF_SACK,
                values: {
                    completed: 1,
                    yards: yards_lost
                }
            },
            stats
        );

        fragment.sackedBy.forEach((player) => {
            const isUnassisted = fragment.sackedBy.length === 1;
            const yardage = isUnassisted ? yards_lost : yards_lost / 2;
            this.addStats(
                {
                    gameId: play.gameId,
                    playId: play.id,
                    period: gameContext.currentPeriod,
                    teamId: player.teamId,
                    playerId: player.id,
                    driveId: gameContext.currentDriveId,
                    fragmentId: fragment.id,
                    category: FootballStatsCategory.DF_SACK,
                    values: {
                        completed: 1,
                        yards: yardage,
                        unassisted: isUnassisted ? 1 : 0
                    }
                },
                stats
            );

            this.addStats(
                {
                    gameId: play.gameId,
                    playId: play.id,
                    period: gameContext.currentPeriod,
                    teamId: player.teamId,
                    playerId: player.id,
                    driveId: gameContext.currentDriveId,
                    fragmentId: fragment.id,
                    category: FootballStatsCategory.TACKLE,
                    values: {
                        completed: 1,
                        yards: yardage,
                        unassisted: isUnassisted ? 1 : 0
                    }
                },
                stats
            );
        });

        return stats;
    }
}
